<template>
  <div>
    <div class="details-component">
      <div class="details-component__header">
        <h1>{{ $t('conferencerules.registration_rules') }}</h1>
        <div class="details-component__header_right" v-if="isLandlord()">
          <router-link :to="{name: 'add-conferencerule', params: { ruleType:'registration' }}" class="link">
          {{ $t('conferencerules.add_rule') }}
          <i class="icon icon--plus"></i>
          </router-link>
        </div>
      </div>

      <div class="rule" v-for="rule in registrationRules(conferencerules)" v-bind:key="rule.id">
        <div class="remove">
          <a v-if="isLandlord()" v-on:click="showDeletingConfirmation(rule.id)" class="link link--orange">{{ $t('common.delete') }}&nbsp;<i class="icon icon--cross"></i>
          </a>
        </div>
        <div class="edit" v-if="isLandlord()">
          <router-link :to="{name: 'edit-conferencerule', params: { ruleId: rule.id }}" class="link">
            {{ $t('common.change') }}
            <i class="icon icon--arrow"></i>
          </router-link>
        </div>
        <div class="period">
          {{ rule.startTime ? formatDate(rule.startTime) : $t('conferencerules.start_now') }} - {{ formatDate(rule.endTime) }}
        </div>
      </div>
    </div>
    <div class="details-component">
      <div class="details-component__header">
        <h1>{{ $t('conferencerules.parking_rules') }}</h1>
        <div class="details-component__header_right" v-if="isLandlord()">
          <router-link :to="{name: 'add-conferencerule', params: { ruleType:'parking' }}" class="link">
          {{ $t('conferencerules.add_rule') }}
          <i class="icon icon--plus"></i>
          </router-link>
        </div>
      </div>

      <div class="rule" v-for="rule in parkingRules(conferencerules)" v-bind:key="rule.id">
        <div class="remove">
          <a v-if="isLandlord()" v-on:click="showDeletingConfirmation(rule.id)" class="link link--orange">{{ $t('common.delete') }}&nbsp;<i class="icon icon--cross"></i>
          </a>
        </div>
        <div class="edit" v-if="isLandlord()">
          <router-link :to="{name: 'edit-conferencerule', params: { ruleId: rule.id }}" class="link">
            {{ $t('common.change') }}
            <i class="icon icon--arrow"></i>
          </router-link>
        </div>
        <div class="period">
          {{ formatDate(rule.startTime) }} - {{ formatDate(rule.endTime) }}
        </div>
      </div>
    </div>
    <ConfirmationModal v-if="showConfirmationModal" @cancel="cancelConferenceRuleDelete" @confirmed="deleteConferenceRule">
      <h1 slot="header">{{ $t('common.deleting') }}</h1>
      <p slot="body">{{ $t('conferencerules.confirm_delete') }}</p>
    </ConfirmationModal>
    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ $t('pricingrules.delete_error_header') }}</h1>
      <p slot="body">{{ $t('conferencerules.delete_error_body') }}</p>
    </WarningModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';
import * as mTypes from 'store/mutation-types';

export default {
  components: {
    ConfirmationModal,
    WarningModal,
  },
  computed: mapGetters({
    conferencerules: 'conferencerules/conferencerules/conferencerules',
    user: 'user/user/user',
    error: 'conferencerules/conferencerule/error',
  }),
  watch: {
    $route: 'fetchConferenceRules',
  },
  route: {
    canReuse: true,
  },
  created() {
    if (this.$route.params.id) {
      this.fetchConferenceRules();
    }
  },
  methods: {
    showDeletingConfirmation(id) {
      this.deleteRuleId = id;
      this.showConfirmationModal = true;
    },
    cancelConferenceRuleDelete() {
      this.deleteRuleId = null;
      this.showConfirmationModal = false;
    },
    deleteConferenceRule() {
      this.showConfirmationModal = false;
      this.$store.dispatch('conferencerules/conferencerule/delete', { id: this.deleteRuleId, user: this.user, productId: this.$route.params.id }).then(() => {
        if (!this.error) {
          this.$store.commit(`conferencerules/conferencerules/${mTypes.REMOVE_DATA}`, this.deleteRuleId);
        } else {
          this.showWarningModal = true;
        }
        this.deleteRuleId = null;
      });
    },
    closeWarningModal() {
      this.showWarningModal = false;
      this.$store.commit(`conferencerules/conferencerule/${mTypes.DATA_ERROR}`, null);
    },
    fetchConferenceRules() {
      if (this.$route.params.id && this.user.data) {
        this.$store.dispatch('conferencerules/conferencerules/fetch', { id: this.$route.params.id, user: this.user });
      }
    },
    parkingRules() {
      return this.conferencerules.filter(this.parkingRulesFilter);
    },
    registrationRules() {
      return this.conferencerules.filter(this.registrationRulesFilter);
    },
    parkingRulesFilter(rule) {
      return rule.type === 'parking';
    },
    registrationRulesFilter(rule) {
      return rule.type === 'registration';
    },
    formatDate(momentDate) {
      return momentDate == null ? '*' : moment(momentDate).format(this.date_time_format);
    },
  },
  data() {
    return {
      minutes_in_hour: 60,
      date_time_format: 'DD.MM.YYYY HH:mm',
      deleteRuleId: null,
      showConfirmationModal: false,
      showWarningModal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
  .rule {border: 1px solid #ccc; padding: 10px; margin: 10px;}
  .add {float: right;}
  .edit {float: right; margin-left: 10px; cursor: pointer; color: 6688dd;}
  .remove {float: right; margin-left: 10px; cursor: pointer; color: 6688dd;}

</style>



// WEBPACK FOOTER //
// src/components/conferencerules/ConferenceRules.vue